import { render, staticRenderFns } from "./SubmitFooter.vue?vue&type=template&id=2924374b&scoped=true&"
import script from "./SubmitFooter.vue?vue&type=script&lang=js&"
export * from "./SubmitFooter.vue?vue&type=script&lang=js&"
import style0 from "./SubmitFooter.vue?vue&type=style&index=0&id=2924374b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2924374b",
  null
  
)

export default component.exports